const OurStorySection = () => {
  return (
    <section className="w-full flex flex-col bg-[#F5E9D7] py-[100px]">
            <div className="w-full flex items-center justify-center mb-[50px]">
                <h1 className="font-bold font-playfair text-4xl text-[#41220E]">Our Story</h1>
            </div>
            <div className="w-full flex items-center justify-center xs:py-[20px]">
                <div className="w-[80%] md:w-[70%] lg:w-[60%] 2xl:w-[50%] bg-[#D4A373] bg-opacity-50 rounded-tr-[80px] rounded-bl-[80px] p-[40px] sm:p-[60px] shadow-md shadow-[#a5815d] border-solid border-b-2 border-r-2 border-[#a5815d]">
                    <p className="font-normal font-playfair xs:text-[15px] text-[18px] sm:text-[22px] lg:text-lg text-center text-[#41220E]">Symphony Artisanal Bakery brings the elegance and charm of classic European patisseries to life, infused with a contemporary flair. 
                        From flaky croissants and delicate Danish pastries to creamy cheesecakes, Italian donuts, and gourmet sandwiches, our bakery offers an exquisite selection of artisanal delights. 
                        With a focus on warm, friendly service in a cozy, inviting atmosphere, Symphony is more than just a bakery—it's a haven for indulgence, comfort, and connection.</p>
                </div>
            </div>
    </section>
  )
}

export default OurStorySection
